import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { IDadosOptout } from "src/app/shared/interfaces/dados-optout.interface";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DescadastreSeService {
  private url = environment.baseUrlApiDigibee;

  constructor(private http: HttpClient) {}

  salvar(dadosOptout: IDadosOptout): Observable<any> {
    return this.http.post<IDadosOptout>(this.url, dadosOptout, { headers: { ApiKey: environment.apiKeyDigibee } });
  }
}
